import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordFieldComponent } from "./password-field.component";
import { SharedModule } from "../../pages/shared-component/shared.module";
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';


@NgModule({
	declarations: [
		PasswordFieldComponent
	],
	exports: [
		PasswordFieldComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		NzToolTipModule
	]
})
export class PasswordFieldModule {
}
